
import { Vue } from "vue-class-component";

export default class ChevronUp extends Vue {}
